/**
 * Andre Garen - Kordon footer yukleyici (Cowork alani, 24 Eylul, v2).
 * Dosya adi eski video footer'dan kaldi (theme.liquid bu dosyayi zaten defer yukluyor).
 * Sayfa acilisinda footer kaynaklarindan HICBIRI istenmez. Sahne JS'i ancak:
 *   1) kullanici ilk kez etkilesince (kaydirma, dokunma, tus, fare tekerlegi),
 *   2) footer'a ~800px kala,
 *   3) tarayici bostayken (requestIdleCallback) eklenir.
 * Boylece kisa sayfalarda (sepet) acilista ana is parcacigi mesgul edilmez.
 * ag-footer-kordon.js dokulari 300px kala yukler, ekran disinda / sekme gizliyken
 * cizimi durdurur. Save-Data / 2g'de sahne hic yuklenmez; statik gravur kalir.
 */
(function () {
  'use strict';
  var k = document.querySelector('[data-kordon]');
  if (!k || !('IntersectionObserver' in window)) return;
  var src = k.getAttribute('data-js');
  if (!src) return;
  var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (c && (c.saveData || /^(slow-2g|2g)$/.test(c.effectiveType || ''))) return;

  var interacted = false, near = false, done = false;
  var EV = ['scroll', 'wheel', 'touchstart', 'pointerdown', 'keydown'];

  function inject() {
    if (done) return;
    done = true;
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    document.head.appendChild(s);
  }
  function maybe() {
    if (done || !interacted || !near) return;
    if ('requestIdleCallback' in window) window.requestIdleCallback(inject, { timeout: 2000 });
    else setTimeout(inject, 200);
  }
  function onFirst() {
    interacted = true;
    EV.forEach(function (e) { window.removeEventListener(e, onFirst, true); });
    maybe();
  }
  EV.forEach(function (e) { window.addEventListener(e, onFirst, { capture: true, passive: true }); });

  var io = new IntersectionObserver(function (e) {
    near = e[0].isIntersecting;
    if (near) maybe();
    if (done) io.disconnect();
  }, { rootMargin: '800px 0px' });
  io.observe(k);
})();
